<template>
    <div>
       <!-- User Interface controls -->
        <b-row>
          <b-col md="2" class="my-1">
            <b-button-group>
              <b-button @click="upcomingSchedule()" class="btn btn-warning btn-sm">
                <span class="icon icon-calendar"> Upcoming</span>
              </b-button>
              <b-button @click="fullSchedule()" class="btn btn-primary btn-sm">
              <span class="icon icon-calendar"> Full</span>
              </b-button>
            </b-button-group>
          </b-col>
            <b-col md="5" class="my-1">
                <b-form-group label-cols="2" class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="5" class="my-1">
                <b-form-group label-cols-md="4" label="Per page" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Main table element -->
            <b-table show-empty empty-text="The schedule will appear here after entering shifts"       striped responsive stacked="md" caption-top
                 :items="items" 
                 :fields="fields" 
                  :filter="filter" 
                  :current-page="currentPage" 
                  :per-page="perPage" 
                  :sort-by.sync="sortBy"
                 @filtered="onFiltered">
            <template v-slot:cell(date)="row">
              {{ moment(row.item.date).format('MMM-DD-YYYY') }}
            </template>
            <template v-slot:cell(evaluation_sent)="row">
              <span v-if="row.item.evaluation_sent == true" class="text-success">Yes</span>
              <span v-else>No</span>
            </template>
            <template v-slot:table-caption>DE = Daily Evaluation</template>
        </b-table>
      <b-row>
          <b-col md="6" class="my-1">
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>
    </div>
</template>

<script>
const items = [];
var moment = require('moment');
export default {
  props: ['schedule', 'user_role', 'students', 'rotations', 'hospital_id'],
  data() {
    return {
      moment: moment,
      items: this.schedule,
      role: this.user_role,
      hospital: this.hospital_id,
      fields: [
        { key: "date", label: "Date" },
        { key: "user.name", label: "Student" },
        { key: "rotation", label: "Rotation"},
        { key: "hospital.hospital", label: "Location"},
        { key: "shift", label: "Shift"},
        { key: "shift_length", label: "Hours"},
        { key: "evaluation_sent", label: "DE Sent"},
      ],
      filter: null,
      sortBy: null,
      currentPage: 1,
      perPage: 25,
      totalRows: this.schedule.length,
      pageOptions: [25, 50, 100],
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fullSchedule() {
        axios.get('/schedule/full/' + this.hospital_id)
            .then(response => this.items = response.data)
            .catch(function (error) {
                // handle error
                console.log(error);
            });
    },
    upcomingSchedule() {
        axios.get('/schedule/future/' + this.hospital_id)
            .then(response => this.items = response.data)
            .catch(function (error) {
                // handle error
                console.log(error);
            });
    },
  },
};
</script>

<!-- table-complete-1.vue -->